// NPM
import React, { useState, useEffect } from "react";
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// api
import api from './api';

// Services
import renderService from 'services/renderService';

// Components
import LineGraph from './LineGraph';

function TimeSeries() {
  // State
  const [timeSeriesData, setTimeSeriesData] = useState([]);
  const responsiveView = useSelector(state => state.responsiveView.value);
  const campaignConfig = useSelector(state => state.campaignConfig.value);
  const partyOrder = useSelector(state => state.partyOrder.value);
  const region = useSelector(state => state.region.value);

  const loadData = async () => {
    const timeSeriesApiData = await api.loadTimeSeriesData();
    const visibleTimeSeriesData = _
      .chain(timeSeriesApiData)
      .filter(td => td.region === region)
      .sortBy(td => partyOrder.indexOf(td.party))
      .value()

    setTimeSeriesData(visibleTimeSeriesData);
  }

  // Hooks
  useEffect(() => loadData(), [region]);

  if(!renderService.canRender([timeSeriesData, region])) {
    return null;
  }

  const title = _.get(campaignConfig, "sections.TimeSeries.title");
  const description = _.get(campaignConfig, "sections.TimeSeries.description");

  return (
    <div className="TimeSeries Signal__section">
      { title && <h2 className="Signal__section-title">{ title }</h2> }
      { description && <p className="Signal__section-description">{ description }</p> }
      <LineGraph timeSeriesData={ timeSeriesData } />
    </div>
  )

}

export default TimeSeries;

